<markdown
  [class.white-text]="whiteText"
  [class.center-text]="centerText">
  <ng-content></ng-content>
</markdown>
